import _ from "lodash";
import React, { useEffect, useState } from "react";
import classes from "./DowntimeAlert.scss";
import { useI18n } from "Hooks";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import { getCloudUrl } from "Constants";
import { formatDate, getGlobalTimezone } from "Utils";
import moment from "moment";
import { withRouter } from "react-router";
import axios from "axios";
import { getPathFromFullPath } from "modules/NavigationModule";
import { underMaintenanceStatusUrl } from "config";
import classNames from "classnames";
import { connect } from "react-redux";
import { addBanner, removeBanner } from "Login/modules/LoginModule";

const DowntimeAlert = ({
  router: { location: { pathname = null } = {} } = {},
  addBanner,
  removeBanner,
}) => {
  const { t } = useI18n(["common"]);

  const [downtimeData, setDowntimeData] = useState({});

  const {
    startDate = null,
    endDate = null,
    shouldAlertAppear = null,
    viewAlertStartDate = null,
  } = downtimeData;

  useEffect(() => {
    if (
      _.includes(["courses", "administrator"], getPathFromFullPath(pathname))
    ) {
      const updateDowntimeData = async () => {
        const newDowntimeData = await axios.get(
          `${getCloudUrl()}/assets/downtime/${underMaintenanceStatusUrl}`
        );

        const newDowntimeDataId = _.get(newDowntimeData, "data.id", null);

        const localStoreValue = !_.isNil(localStorage)
          ? JSON.parse(localStorage.getItem("downtimeData") || "{}")
          : {};

        setDowntimeData({
          ...newDowntimeData.data,
          shouldAlertAppear: _.get(localStoreValue, newDowntimeDataId, true),
        });

        //Clear local storage if a new downtime banner appears
        if (
          !_.has(localStoreValue, newDowntimeDataId) &&
          !_.isNil(localStorage) &&
          !_.isNil(localStorage.getItem("downtimeData"))
        ) {
          localStorage.removeItem("downtimeData");
        }
      };

      updateDowntimeData();
    }
  }, [pathname]);

  const showAlert =
    shouldAlertAppear &&
    moment().diff(moment(viewAlertStartDate), "seconds") > 0 &&
    moment(startDate).diff(moment(), "seconds") > 0;

  useEffect(() => {
    if (showAlert) {
      addBanner("DOWNTIME_ALERT");
    } else {
      removeBanner("DOWNTIME_ALERT");
    }
  }, [showAlert]);

  const handleOnAlertCloseClick = () => {
    setDowntimeData({ ...downtimeData, shouldAlertAppear: false });
    if (!_.isNil(localStorage)) {
      localStorage.setItem(
        "downtimeData",
        JSON.stringify({ [downtimeData?.id]: false })
      );
    }
  };

  const alertTextClass = classNames("text-body-3", classes.alertText);

  return showAlert ? (
    <div className={classes.alertContainer}>
      <div className={alertTextClass}>
        {t("common:downtime_banner_message", {
          startDate: formatDate({
            date: startDate,
            format: "Do MMMM, YYYY",
          }),
          startTime: formatDate({ date: startDate, format: "h:mm A" }),
          count: moment(endDate).diff(moment(startDate), "hours"),
          timeZone: moment.tz(getGlobalTimezone()).format("z"),
        })}
      </div>
      <CloseOutlined
        cursor={"pointer"}
        onClick={handleOnAlertCloseClick}
        size={"xx-small"}
      />
    </div>
  ) : null;
};

export default withRouter(
  connect(null, { addBanner, removeBanner })(DowntimeAlert)
);
